import React from 'react';
import DatePicker, { registerLocale } from "react-datepicker"
import es from "date-fns/locale/es";
import "./styles.css";
import "./custom.scss";
require('react-datepicker/dist/react-datepicker.css')

registerLocale("es", es);

class InputDateComponent extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      startDate: '',
      maxDate: new Date(),
      minDate: '',
    };
  
    this.handleChange = this.handleChange.bind(this);
  }
  
  render() {

    return (
    <DatePicker
          dateFormat="dd/MM/yyyy"
          selected={this.state.startDate}
          onChange={this.handleChange}
          className="customStyle"
          minDate={this.state.minDate}
          maxDate={this.state.maxDate}
          locale="es"
        />
      )
  }

  handleChange = date => {
    this.setState({
      startDate: date
    });
    this.props.onChange(date); 
  };

}

export default InputDateComponent;